import React from 'react';
import PropTypes from 'prop-types';
import PrintSizeType from '../types/print-size-type';
import Pluralizer from '../pluralizer';
import { builderDispatch } from '../../_utils/ui';
import CartItemsChangeEvents from '../cart-items-change-events';

const PrintsAllDeleted = ({ deletedFinish, sizes }) => {
  const deletedSizes = sizes.filter(
    ({ print_finish_key }) => deletedFinish === print_finish_key
  );
  const niceFinishTitle = (deletedSizes[0] || {}).finish;
  const quantity = deletedSizes.reduce((memo, size) => memo + size.quantity, 0);

  return (
    <div className="alert alert-warning deleted-warning" role="alert">
      <Pluralizer
        count={quantity}
        singular={`${niceFinishTitle} print has`}
        plural={`${niceFinishTitle} prints have`}
      />
      &nbsp;been deleted.&nbsp;
      <a href="#" onClick={handleUndelete}>
        Undo
      </a>
    </div>
  );

  function handleUndelete(e) {
    e.preventDefault();

    builderDispatch.dispatch({
      type: CartItemsChangeEvents.UNREMOVE_PRINTS,
      finish: deletedFinish,
    });
  }
};

PrintsAllDeleted.propTypes = {
  deletedFinish: PropTypes.string.isRequired,
  sizes: PropTypes.arrayOf(PrintSizeType),
};

export default PrintsAllDeleted;
